import { render } from "./BeneficialOwners.vue?vue&type=template&id=12a1b051&ts=true"
import script from "./BeneficialOwners.vue?vue&type=script&lang=ts"
export * from "./BeneficialOwners.vue?vue&type=script&lang=ts"

import "./BeneficialOwners.vue?vue&type=style&index=0&id=12a1b051&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__